import { inject, Injectable } from "@angular/core";

import { IHttpResponseHandlerSettings } from "@bbwt/modules/data-service";
import { QuerySourceService } from "@main/reporting.v3/api/query-source.service";
import { IQueryPageRequest, IQuerySourcePreload } from "@main/reporting.v3/core/reporting-models";

import { QueryData, QueryResolver } from "../models";


@Injectable()
export class QueryResolverService implements QueryResolver {

    private querySourceService: QuerySourceService = inject(QuerySourceService);

    public async getQueryId(queryName: string): Promise<string> {
        if (!queryName?.length) return null;

        const settings: IHttpResponseHandlerSettings = { showErrorMessage: false };

        const preload: IQuerySourcePreload = await this.querySourceService.getQuerySourcePreload(queryName, settings);

        return preload?.id;
    }

    public async getQuery(querySourceId: string, request: IQueryPageRequest): Promise<QueryData> {
        if (!querySourceId || !request) return null;

        const settings: IHttpResponseHandlerSettings = { showErrorMessage: false };

        return this.querySourceService.getQueryData(querySourceId, request, settings);
    }
}